<template>
  <div>
    <div v-show="error !== ''">
      <v-alert
        :value="true"
        type="error">
        {{ error }}
      </v-alert>
    </div>

    <div v-show="loading" class="text-xs-center">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>

    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
      v-show = "!loading"
    >
      <v-text-field
        v-model="place"
        label="宿泊先 (必須)"
        required
        clearable
      ></v-text-field>

      <v-text-field
        v-model="address"
        label="宿泊先住所 (必須)"
        required
        clearable
      ></v-text-field>

      <v-menu
        ref="menu1"
        v-model="menu1"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="begin"
        lazy
        transition="scale-transition"
        offset-y
        full-width
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="begin"
            label="出発日 (必須)"
            prepend-icon="event"
            readonly
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker v-model="begin" no-title scrollable locale="ja-jp">
          <v-spacer></v-spacer>
          <v-btn flat color="primary" @click="menu1 = false">Cancel</v-btn>
          <v-btn flat color="primary" @click="$refs.menu1.save(begin)">OK</v-btn>
        </v-date-picker>
      </v-menu>

      <v-menu
        ref="menu2"
        v-model="menu2"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="end"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="end"
            label="帰館日 (必須)"
            prepend-icon="event"
            readonly
            v-on="on"
            ></v-text-field>
        </template>
        <v-date-picker v-model="end" no-title scrollable locale="ja-jp">
          <v-spacer></v-spacer>
          <v-btn flat color="primary" @click="menu2 = false">Cancel</v-btn>
          <v-btn flat color="primary" @click="$refs.menu2.save(end)">OK</v-btn>
        </v-date-picker>
      </v-menu>

      <v-text-field
        v-model="purpose"
        label="目的 (必須)"
        required
        clearable
      ></v-text-field>

      <v-text-field
        v-model="tour"
        label="ツアー名 (ツアーを利用する場合))"
        clearable
      ></v-text-field>

      <v-text-field
        v-model="company"
        label="ツアー会社名 (ツアーを利用する場合)"
        clearable
      ></v-text-field>

      <v-text-field
        v-model="tour_tel"
        label="ツアー会社の連絡先 (ツアーを利用する場合)"
        clearable
      ></v-text-field>

      <v-layout align-center justify-end row fill-height>
        <v-btn @click="submit" color="success">申請する</v-btn>
      </v-layout>
    </v-form>

    <template>
      <v-layout row justify-center>
        <v-dialog
          v-model="dialog"
          max-width="290"
        >
          <v-card>
            <v-card-title class="headline">{{dialog_title}}</v-card-title>

            <v-card-text>
              {{dialog_content}}
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color='info'
                @click="dialog = false"
              >
                OK
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </template>
  </div>
</template>

<script>
export default {
  methods: {
    async submit() {
      window.scrollTo(0, 0)
      this.error = ""
      this.loading = true
      try {
        if(this.num2date(this.end).isSameOrBefore(this.num2date(this.begin))){
          throw new Error("出発日と帰館日が逆転しています")
        }

        if(this.num2date(this.begin).isBefore(this.$moment().add(-6, 'hour'), 'day')){
          throw new Error("出発日に過去の日付が設定されています")
        }

        await this.api('lodging_new', {lodging: {from: this.date2num(this.begin), until: this.date2num(this.end), place: this.place, location: this.address, purpose: this.purpose, tour_name: this.tour, tour_company: this.company, tour_contact: this.tour_tel}})
        this.dialog = true
        this.dialog_title = "完了"
        this.dialog_content = "外泊の申請が完了しました。"
        if(this.$moment(this.begin).isSameOrBefore(this.$moment().add(-6, 'hour').add(3, 'days'), 'day')){
          this.dialog = "外泊が3日以内であるため、館長に電話で連絡を入れる必要があります。忘れずに行ってください。"
        }
      }
      catch (e) {
        this.error = e.name + ": " + e.message
      }
      finally{
        this.loading = false
      }
    },
  },
  data () {
    return {
      valid: true,
      menu1: false,
      menu2: false,
      place: "",
      address: "",
      begin: new Date().toISOString().substr(0, 10),
      end: new Date().toISOString().substr(0, 10),
      purpose: "",
      tour: "",
      company: "",
      tour_tel: "",
      user: localStorage.user || "",
      error: "",
      dialog: false,
      dialog_content: '',
      dialog_title: '',
      loading: false
    }
  },
}
</script>
